import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ButtonHTMLAttributes } from 'react';
import type { ButtonProps } from '../../components/button/types';
import type { AllIconType } from '../../util/types';
import { Button } from '../../components';
import { GLOBAL_ICONS } from '../../util/vars';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;
interface Props extends ButtonProps, HTMLProps {
  icon?: AllIconType;
  isLoading?: boolean;
  children?: string | null,
}

const ConfirmButtonModal = ({
  icon = GLOBAL_ICONS.confirm,
  children,
  ...other
}: Props): JSX.Element => {

  const { translate } = useI18n();

  return (
    <Button isOutline color={'positive'} icon={icon} data-cy="confirm-button-modal"  {...other}>
      {children ?? translate('components.BUTTONS.CONFIRM')}
    </Button>
  );
};

ConfirmButtonModal.displayName = 'ConfirmButtonModal';

export default ConfirmButtonModal;
